module.exports = __webpack_public_path__ + "img/fondo1.89f67df5.png";